import {
	all,
	takeEvery,
	put
} from "redux-saga/effects";
import ApiService from "../../Services/ApiService";
import { saveContacts, saveSegments } from "../actions/Contacts";
import {
	GET_CONTACT,
	GET_SEGMENTS,
} from "../constants/Contacts";
import { toastNotification } from "../../utils/toastNotification";

function* getContacts() {
	yield takeEvery(GET_CONTACT, function* (action) {
		try {
			const res = yield ApiService.get(
				`/ironman/visitors?showCount=true`, {},
				{
					filter: {
						...action.payload.filter,
						offset: action.payload.offset,
						limit: action.payload.limit
					}
				}
			);
			yield put(saveContacts(res.data));
		} catch (error) {
			yield put(console.log(error));
		}
	});
}

function* getSegments() {
	yield takeEvery(GET_SEGMENTS, function* (action) {
		try {
			const res = yield ApiService.get("/hulk/api/v1/contact-segments");

			if (res.status != "success") {
				toastNotification({errorMessage: "Unable to load segments"});
				return;
			}
			yield put(saveSegments(res.data));
		} catch (error) {
			console.log(error)
			toastNotification({errorMessage: "Unable to load segments"});
			return;
		}
	});
}

export default function* rootSaga() {
	yield all([
		getContacts(),
		getSegments()
	]);
}
